<template>
  <div>
    <b-row>
      <b-col>
        <InputSelect
          title="Option Format"
          name="type"
          isRequired
          v-model="button.ButtonTypeId"
          :options="buttonTypeList"
          valueField="id"
          textField="name"
          @onDataChange="handleChangeType"
        />
      </b-col>
      <b-col>
        <InputText
          textFloat="Sort Order"
          v-model="button.SortOrder"
          placeholder="Sort Order"
          type="number"
          name="sortOrder"
        />
      </b-col>
    </b-row>

    <!-- <b-row class="">
      <b-col>
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-radio
            v-model="button.IsDefinedFlow"
            :aria-describedby="ariaDescribedby"
            :name="'some-radios' + buttonIndex"
            :value="button.IsDefinedFlow"
          >
            New Button</b-form-radio
          >
        </b-form-group>
      </b-col>
    </b-row> -->

    <template v-if="!button.IsDefinedFlow">
      <b-row>
        <b-col>
          <InputText
            v-model="button.Label"
            textFloat="Option Name"
            placeholder="Option Name"
            type="text"
            name="text"
            isRequired
            :lightText="true"
            :maxLength="40"
            :isValidate="v.Label.$error"
            :v="v.Label"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <InputText
            v-model="button.Data"
            textFloat="Action Name/Intent Name"
            placeholder="Action Name/Intent Name"
            type="text"
            name="text"
            isRequired
            :lightText="true"
            :maxLength="40"
            :isValidate="v.Data.$error"
            :v="v.Data"
          />
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
export default {
  components: {
    InputText,
    InputSelect,
  },
  props: {
    button: {
      required: true,
      type: Object,
    },
    buttonIndex: {
      required: false,
      type: Number,
    },
    v: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      isNewButton: false,
      buttonTypeList: [
        {
          id: 1,
          name: "Button",
        },
        {
          id: 2,
          name: "Quick Reply",
        },
      ],
    };
  },
  methods: {
    handleChangeType(value) {
      this.button.ButtonTypeId = value;
    },
  },
};
</script>

<style lang="scss" scoped></style>
